export const fmt = {
  eur(n) {
    return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n || 0));
  },
  dt(iso) {
    if (!iso) return "-";
    try {
      return new Date(iso).toLocaleString("it-IT", {
        timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit",
      });
    } catch { return iso; }
  },
  time(iso) {
    if (!iso) return "-";
    return new Date(iso).toLocaleTimeString("it-IT", { timeZone: "Europe/Rome", hour: "2-digit", minute: "2-digit" });
  },
  ago(iso) {
    const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
    if (s < 60) return `${s}s fa`;
    const m = Math.floor(s / 60);
    if (m < 60) return `${m}m fa`;
    return `${Math.floor(m / 60)}h ${m % 60}m fa`;
  },
};
